export enum Era {
    Enterprise,
    OriginalSeries,
    NextGeneration,
    PicardProdigy,
    Discovery32
}

